<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item label="认证状态">
              <a-select v-model="queryParam.certificationStatus" placeholder="请选择认证状态">
                <a-select-option value="">请选择</a-select-option>
                <a-select-option value="0">未认证</a-select-option>
                <a-select-option value="1">认证中</a-select-option>
                <a-select-option value="2">已认证</a-select-option>
                <a-select-option value="3">认证失败</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('doctor_certification')">导出</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
           <a @click="certDetail(record)">查看详情</a>
        </span>
      </a-table>
    </div>

    <doctor-certification-modal ref="modalForm" @ok="modalFormOk"></doctor-certification-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DoctorCertificationModal from './DoctorCertificationModal'
  import { getAction } from '@api/manage'

  export default {
    name: 'DoctorCertificationList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      DoctorCertificationModal,
    },
    data () {
      return {
        description: 'doctor_certification管理页面',
        // 表头
        columns: [
          {
            title:'医生id',
            width: 150,
            align:"center",
            dataIndex: 'id'
          },
          {
            title:'医生姓名',
            width: 150,
            align:"center",
            dataIndex: 'name'
          },

          {
            title: '认证状态',
            align: "center",
            dataIndex: 'certificationStatus',
            customRender:function (res) {
              var status = "";
              if(res == 0){
                status = "未认证";
              }else if(res == 1){
                status = "认证中";
              }else if(res == 2){
                status = "已认证";
              }else if(res == 3){
                status = "认证失败";
              }
              return status;
            }
          },
          {
            title:'创建时间',
            align:"center",
            dataIndex: 'createTime',
            customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:247,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/doctor/doctor/certList",
          queryDoctor: "/doctor/doctorCertification/queryByDoctorId",
        },
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      certDetail(e){
        let param = {};
        param.doctor_id = e.id;
        getAction(this.url.queryDoctor,param).then(res=>{
          if(res.result == null){
            this.$message.warning("该医生还未进行认证");
          }else{
            this.handleEdit(res.result);
          }
        })
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>